import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  container: {
    height: '100vh'
  },
  background: {
    height: '100vh',
    background: theme.palette.primary.main
  },
  logo: {
    fontWeight: 100,
    letterSpacing: 2,
    color: theme.palette.common.white
  },
  card: {
    minWidth: 350,
    padding: 20
  },
  header: {
    textAlign: 'center'
  },
  action: {
    margin: '10px 0'
  },
  underline: {
    '&:after': {
      backgroundColor: theme.palette.primary.light
    }
  },
  label: {
    color: theme.palette.primary.light
  },
  button: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    width: '100%',
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px 0px rgba(0, 0, 0, 0.14),0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
	  borderRadius: '4px',
  	'&:active': {
	    boxShadow: '0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 12px 17px 2px rgba(0, 0, 0, 0.14),0px 5px 22px 4px rgba(0, 0, 0, 0.12)'
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
});



class LoginPage extends Component {
  render() {
    const { classes, redirectUrls } = this.props;

    return (
      <div className={classes.background}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.root}
        >
          <Grid item>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              className={classes.container}
            >
              <Grid item>
                <Typography
                  variant="h1"
                  align="center"
                  gutterBottom
                  paragraph
                  className={classes.logo}
                >
                  Galileo
                </Typography>
              </Grid>

              <Grid item>
                <Card className={classes.card}>
                  <CardHeader className={classes.header} title="Login" />
                  <Divider />
                  <CardContent>
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      alignItems="stretch"
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        href={`${window.runConfig.REACT_APP_API_URL}/auth/google?${redirectUrls}`}
                      >
                        Login with Google
                      </Button>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )}
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  redirectUrls: PropTypes.string.isRequired
};


export default withStyles(styles)(LoginPage);
